<template>
  <div
    class="column"
    style="max-width:100%; height: 100%"
  >
    <div class=" bg-blue-grey-1 label-queue">
      <div class="row justify-center">
        <span class="q-my-xs"><QueueSelect v-model="selectedQueueId" /></span>
      </div>
    </div>
    <div
      v-if="!selectedQueueId"
      class=" col padding-panel row full-width justify-between"
    >
      <PanelPreviewAlert
        title="Bem vindo ao modo Preview !"
        subtitle-title="Nenhuma fila selecionada"
        subtitle-text="Selecione uma fila para carregar os contatos"
      />
    </div>

    <div
      v-else
      class="col padding-panel row"
      style="height: 100%"
    >
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script>
import PanelPreviewAlert from '@/components/PanelPreviewAlert.vue'
import QueueSelect from '@/components/QueueSelect.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { QueueSelect, PanelPreviewAlert },

  props: {
    attendanceId: {}
  },

  data () {
    return {
      tab: 'general',
      openSplitter: false,
      profilerSelected: {},
      phones: ['996510404'],
      selectedQueueId: null
    }
  },

  mounted () {
    this.selectedQueueId = this.$route.params.queueId ?? this.previewQueue
  },
  computed: {
    ...mapGetters({
      isAdmin: 'settingsModule/isAdmin',
      previewQueue: 'attendanceModule/previewQueue'
    })

  },
  methods: {
    ...mapActions({
      setPreviewQueue: 'attendanceModule/setPreviewQueueId'
    })
  },
  watch: {

    selectedQueueId (newQueueId) {
      if (newQueueId === this.previewQueue) return
      this.setPreviewQueue(newQueueId)
    }
  }
}

</script>

<style lang="sass" scoped>
.padding-panel
  padding: 1%

@media only screen and (max-width: 1400px)
  .padding-panel
    padding: 0
    background-color: white
</style>
